<fgb-page-header
  [pageTitle]="'rewards.nav.wallet'"
  [backButtonLink]="'/rewards/wallet'"
  [showBalance]="false"
  [showQr]="false"
></fgb-page-header>

<div class="container pt-4">
  <div class="back-btn bg-primary d-none d-lg-flex" [routerLink]="'/rewards/wallet'">
    <span class="material-symbols-outlined text-white"> arrow_back_ios_new </span>
  </div>

  <fgbcl-marketplace-wallet-details [id]="id"></fgbcl-marketplace-wallet-details>
</div>
